module.exports = __webpack_public_path__ + "6ebb00489bfbce02f05e47dff6e6ca5e.svg";